import "../../chunk-5WRI5ZAA.js";

// src/timeline/timelinePostMessage/timelinePostMessage.constant.ts
var TIMELINE_CHANNEL_ID = "timeline";
var timelinePostMessageEvents = {
  SEND_CURRENT_BASE_ROUTE: "send-current-base-route",
  SEND_CSLP_DATA: "send-cslp-data",
  DIFF_VALUE: "diff-value",
  REMOVE_DIFF: "remove-diff"
};
export {
  TIMELINE_CHANNEL_ID,
  timelinePostMessageEvents
};
//# sourceMappingURL=timelinePostMessage.constant.js.map